const ROW_META_KEYS = new Set([
  'sortOrder',
  'dataItemMetadata',
  // Data item definitions include server-only metadata not present on pending NEW_ rows.
  'hasExpression',
  'dataTypeName',
  'aliasName',
  'aliasType',
  'error',
]);

const normalizeContentValue = value => {
  if (value === true) {
    return true;
  }

  // Treat unset server values (null) as equivalent to client-side defaults
  // (false for booleans, '0' for numeric fields, empty strings).
  if (value == null || value === '' || value === false || value === 0 || value === '0') {
    return null;
  }

  return String(value);
};

export const getRowContentForComparison = (row, getUniqueRowId) => {
  const rowId = getUniqueRowId({ data: row });

  return Object.fromEntries(
    Object.entries(row)
      .filter(([key, value]) => {
        if (ROW_META_KEYS.has(key)) {
          return false;
        }

        if (rowId != null && rowId !== '' && value === rowId) {
          return false;
        }

        return true;
      })
      .map(([key, value]) => [key, normalizeContentValue(value)]),
  );
};

export const rowsHaveSameContent = (rowA, rowB, getUniqueRowId) => {
  const contentA = getRowContentForComparison(rowA, getUniqueRowId);
  const contentB = getRowContentForComparison(rowB, getUniqueRowId);
  const allKeys = new Set([...Object.keys(contentA), ...Object.keys(contentB)]);

  return [...allKeys].every(key => (contentA[key] ?? null) === (contentB[key] ?? null));
};
